// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"73130c78","703":"2c64922a"}[chunkId] + ".chunk.js";
};